export function prepareScreenshot(document, element) {
  // html2canvas 还会读取 html/body 底色，不支持 oklch 等新颜色格式。
  document.documentElement.style.setProperty(
    "background-color",
    "#f5f7fa",
    "important",
  );
  document.body.style.setProperty("background-color", "#f5f7fa", "important");
  document.body.appendChild(element);
  element.style.position = "absolute";
  element.style.left = "0";
  element.style.top = "0";
  // 用浏览器转换新颜色格式，仅修改截图副本，包含阴影、渐变和伪元素。
  const colorCanvas = document.createElement("canvas");
  colorCanvas.width = colorCanvas.height = 1;
  const context = colorCanvas.getContext("2d", {
    willReadFrequently: true,
  });
  const pseudoStyles = document.createElement("style");
  [element, ...element.querySelectorAll("*")].forEach((node, index) => {
    node.setAttribute("data-screenshot-color", index);
    [null, "::before", "::after"].forEach((pseudo) => {
      const computed = document.defaultView.getComputedStyle(node, pseudo);
      const targetStyle = pseudo
        ? document.createElement("span").style
        : node.style;
      Array.from(computed).forEach((property) => {
        const value = computed.getPropertyValue(property);
        if (!/\b(?:oklch|oklab|lch|lab|color)\(/.test(value)) return;
        const converted = value.replace(
          /\b(?:oklch|oklab|lch|lab|color)\([^()]*\)/g,
          (color) => {
            context.clearRect(0, 0, 1, 1);
            context.fillStyle = color;
            context.fillRect(0, 0, 1, 1);
            const [r, g, b, a] = context.getImageData(0, 0, 1, 1).data;
            return `rgba(${r}, ${g}, ${b}, ${a / 255})`;
          },
        );
        targetStyle.setProperty(property, converted, "important");
      });
      if (pseudo && targetStyle.cssText) {
        pseudoStyles.textContent += `[data-screenshot-color="${index}"]${pseudo}{${targetStyle.cssText}}`;
      }
    });
  });
  document.head.appendChild(pseudoStyles);
}
